import * as _ from 'lodash';

angular.module("tromanWeb").directive("ergoCombo", ['$parse', '$exceptionHandler', function ($parse) {

    var optionsRe = /^\s*([\s\S]+?)\s+for\s+([$\w][$\w]*)\s+in\s+([\s\S]+?)\s+(track\s+by|save\s+as)\s+([\s\S]+?)(\s+group\s+by\s+([\s\S]+?))?\s*$/;
    function parseConfiguration(scope, attributes) {

        var match = attributes.ergoOptions.match(optionsRe);
        if (match == null) {
            throw 'Invalid Expression: "' + attributes.ergoOptions + '"';
        }

        var name = match[2];
        var labelfn = $parse(match[1]);
        var idfn = $parse(match[5]);
        var colfn = $parse(match[3]);

        var hasGroup = !!match[6] && attributes.ergoGroup;
        var groupFn = hasGroup && $parse(match[7]);

        return {
            isMultiple: !!attributes.multiple,
            byreference: !!attributes.byreference,
            saveId: match[4].startsWith('s'),
            getLabel: function (obj) {
                let locals = { [name]: obj };
                return labelfn(scope, locals);
            },
            getId: function (obj) {
                let locals = { [name]: obj };
                return idfn(scope, locals);
            },
            getCollection: function () {
                var src = colfn(scope);
                if (_.isArray(src)) {
                    return src;
                }
            },
            hasGroup: hasGroup,
            getGroup: hasGroup ? (function (obj) {
                let locals = { [name]: obj };
                return !!groupFn(scope, locals);
            }) : (function () { }),
            groupName: attributes.ergoGroup,
        };
    }

    function createReactOptions(configuration, sourceObjects) {
        const result = [];
        const resultMap = new Map();
        const group = [];
    
        _.forEach(sourceObjects, src => {
            let option = {
                label: configuration.getLabel(src),
                value: configuration.getId(src),
                source: src,
            };
    
            resultMap.set(option.value, option);
    
            if (configuration.hasGroup && configuration.getGroup(src)) {
                group.push(option);
            } else {
                result.push(option);
            }
        });
    
        if (group.length > 0) {
            result.push({
                label: configuration.groupName,
                options: group,
            });
        }
    
        return [result, resultMap];
    }

    return {
        restrict: "E",
        require: ["ergoCombo", "ngModel"],
        scope: {},
        template: function (_element, attrs) {
            const component = attrs.multiple ? 'react-select-multi' : 'react-select-single';
            return `<${component} \
                input-id="$ctrl.inputId" \
                tab-index="$ctrl.tabIndex" \
                placeholder="$ctrl.placeholder" \
                is-disabled="$ctrl.isDisabled" \
                options="$ctrl.reactOptions" \
                value="$ctrl.reactValue" \
                on-change="$ctrl.handleChange" \
                ></${component}>`;
        },
        compile: function (tElement) {
            tElement.addClass('ergo-combo');
            
            function forwardAttribute(name) {
                if (tElement.attr(name)) {
                    var val = tElement.attr(name);
                    tElement.removeAttr(name);
                    return val;
                }
            }

            const tId = forwardAttribute('id');
            const tTabIndex = forwardAttribute('tabindex');
            return function (_scope, _element, _attributes, [ergoComboCtrl, modelCtrl]) {
                ergoComboCtrl.init(modelCtrl, tId, tTabIndex);
            };
        },
        controllerAs: '$ctrl',
        controller: ['$scope', '$attrs', function ($scope, $attrs) {
            this.reactOptions = [];
            this.reactOptionsById = new Map();
            this.reactValue = null;
            this.inputId = void(0);
            this.tabIndex = void(0);
            this.isDisabled = false;
            this.placeholder = void(0);
            
            this.handleChange = (value) => { this.reactValue = value; };

            const configuration = parseConfiguration($scope.$parent, $attrs, $parse);

            this.init = (modelCtrl, inputId, tabIndex) => {
                this.inputId = inputId;
                this.tabIndex = tabIndex;
                        
                var optionToModel, modelToOption;

                if (configuration.saveId) {
                    optionToModel = option => option ? option.value : void(0);
                    modelToOption = id => this.reactOptionsById.get(id) || null;
                } else {
                    optionToModel = option => option ? option.source : void(0);
                    modelToOption = obj => this.reactOptionsById.get(configuration.getId(obj)) || null;
                }

                if (configuration.isMultiple) {
                    let otm = optionToModel;
                    optionToModel = options => _.reject(_.map(options, otm), _.isNil);
                    let mto = modelToOption;
                    modelToOption = models => _.reject(_.map(models, mto), _.isNil);
                }
            
                this.handleChange = (value) => {
                    this.reactValue = value;
                    
                    modelCtrl.$setViewValue(optionToModel(value));
                };
                
                modelCtrl.$render = () => {
                    this.reactValue = modelToOption(modelCtrl.$viewValue);
                };

                if (configuration.isMultiple) {
                    modelCtrl.$isEmpty = x => x == null || x.length == 0;
                } else {
                    modelCtrl.$isEmpty = x => x == null;
                }

                
                /**
                 * Determines if the model has changed.
                 * Only checks if the newModel is empty/missing values that was in oldModel.
                 * @param {any} oldModel
                 * @param {any} newModel
                 */
                function hasModelChanged(oldModel, newModel) {
                    if (!modelCtrl.$isEmpty(oldModel)) {
                        if (modelCtrl.$isEmpty(newModel)) {
                            return true;
                        }

                        if (configuration.isMultiple) {
                            if (oldModel.length !== newModel.length) {
                                return true;
                            }
                        }
                    }
                }

                // Callback when the collection changes.
                const watchCallback = (newCollection, oldCollection) => {
                    // The view value is updated (at the end of this function) when the collection changes
                    // and the new collection does not contain the old value.
                    // If the collection is empty/undefined, this means that the view value is cleared.
                    //
                    // For the first run, this behaviour is supressed so that the the collection can load
                    // asynchronously even when the model/view value is immediately available.
                    if (newCollection === oldCollection && angular.isUndefined(newCollection)) return;

                    var oldModel = modelCtrl.$viewValue;

                    [this.reactOptions, this.reactOptionsById] = createReactOptions(configuration, newCollection);

                    var newReactValue = modelToOption(oldModel);
                    var newModel = optionToModel(newReactValue);

                    this.reactValue = newReactValue;

                    if (hasModelChanged(oldModel, newModel)) {
                        modelCtrl.$setViewValue(newModel);
                    }
                };

                if (configuration.byreference) {
                    $scope.$watch(configuration.getCollection, watchCallback);
                } else {
                    $scope.$watchCollection(configuration.getCollection, watchCallback);
                }

                // Support for enabled/disabled
                $attrs.$observe('disabled', (value) => {
                    this.isDisabled = !!value;
                });

                if ($attrs.ergoPlaceholder) {
                    this.placeholder = $scope.$parent.$eval($attrs.ergoPlaceholder);
                } else {
                    this.placeholder = $attrs.placeholder;
                }
            };
        }],
    };
}]);
